"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractBlockchain = void 0;
class AbstractBlockchain {
    name;
    id;
    vm;
    asset;
    assetId;
    aliases;
    registeredAssets = new Map();
    constructor(name, id, vm, asset, aliases = [], registeredAssets = []) {
        this.name = name;
        this.id = id;
        this.vm = vm;
        this.asset = asset;
        this.assetId = asset.assetId;
        this.aliases = aliases;
        for (const asset of registeredAssets) {
            this.addRegisteredAsset(asset);
        }
        this.addRegisteredAsset(asset);
    }
    getRegisteredAssets() {
        return this.registeredAssets.values();
    }
    addRegisteredAsset(asset) {
        this.registeredAssets.set(asset.assetId, asset);
    }
    async getAsset(provider, assetId) {
        if (this.registeredAssets.has(assetId)) {
            return this.registeredAssets.get(assetId);
        }
        const asset = await this.fetchAsset(provider, assetId);
        this.addRegisteredAsset(asset);
        return asset;
    }
}
exports.AbstractBlockchain = AbstractBlockchain;
